// extracted by mini-css-extract-plugin
export var btnSearch = "btn-search-module--btnSearch--7ceea";
export var searchContainer = "btn-search-module--searchContainer--52ce6";